import React from 'react'
import { translate } from 'utils/propKeysTranslations'

export const FieldWithContent = ({ fieldName, children }) => {
  return (
    <div >
      <p className='block text-gray-700 text-sm font-bold pt-2 pb-1'>
        {translate(fieldName)}
      </p>
      {children}
    </div>
  )
}
